import React, { useRef } from 'react';

import { type Table } from '@tanstack/react-table';

import { Box, type BoxProps } from '@atlaskit/primitives/compiled';

import { useTableHeightEffect } from './hooks/table-effects/use-table-height-effect';
import { useTablePinningEffects } from './hooks/table-effects/use-table-pinning-effects';
import { useMergeRefs } from './hooks/use-merge-refs';

interface CharlieTableMinimalDndWrapperProps<T extends object> extends BoxProps<'div'> {
	charlieTableState: Table<T>;
	children: React.ReactNode;
	tableRef: React.RefObject<HTMLTableElement>;
	tbodyRef: React.RefObject<HTMLTableSectionElement>;
}

export const CharlieTableMinimalDndWrapper = React.forwardRef(
	<T extends object>(
		{
			charlieTableState,
			children,
			tableRef,
			tbodyRef,
			...props
		}: CharlieTableMinimalDndWrapperProps<T>,
		ref: CharlieTableMinimalDndWrapperProps<T>['ref'],
	) => {
		const internalRef = useRef<HTMLDivElement | null>(null);
		const mergedRef = useMergeRefs(internalRef, ref);

		useTableHeightEffect({ tableRef });
		useTablePinningEffects({
			tableRef,
			wrapperRef: internalRef,
			tbodyRef,
			charlieTableState,
		});

		return (
			<Box ref={mergedRef} {...props}>
				{children}
			</Box>
		);
	},
);
